import { apiClient } from "@/api"
import Alerter from "@/common/alerter"
import CreateOrUpdateForm from "@/components/school_admins/users/actions/create_or_update_form"
import { RECEIVE_SESSIONS_OPTIONS, SCHOOL_ADMIN_MESSAGES, SCHOOL_ADMIN_PATHS } from "@/constants"
import React from "react"

const EditSchoolAdmin = ({ schoolAdmin, schools, receiveSessions }) => {
  const onSubmit = async (event, id, email, firstName, lastName, receiveSessions, schoolId) => {
    event.preventDefault()

    const school_admin = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      school_id: schoolId,
      receive_session_reports: receiveSessions === RECEIVE_SESSIONS_OPTIONS.YES,
    }

    try {
      await apiClient.put(`${SCHOOL_ADMIN_PATHS.apiBase}/${id}`, school_admin)
      Alerter.success(SCHOOL_ADMIN_MESSAGES.updateSuccess)
      window.location.replace(SCHOOL_ADMIN_PATHS.users)
    } catch (error) {
      Alerter.error(error.response.data.error)
    }
  }

  return (
    <CreateOrUpdateForm
      title={"Edit School Admin"}
      onSubmit={onSubmit}
      initialValues={{ schoolAdmin, receiveSessions }}
      schoolsList={schools}
    />
  )
}

export default EditSchoolAdmin
